import axios from '../../apis/apicidtech';
import { types } from '../../types/types';
import { getToken } from '../../utils/tokencidtechapi';
import { dispatchpending, dispatchresponse, dispatchresponseerror } from '../utils/dispatches';

export const novo = (dados = {}) => {
    
    return async dispatch => {

        dispatchpending(dispatch);

        try{
            const response = await axios.post('credenciais/credencial/novo',
                {
                    ...dados
                },
                {
                    headers:{
                        Accept: 'application/json',
                        Authorization: `Bearer ${getToken()}`
                    }
                }
            );
            
            dispatchresponse(dispatch,response.data[0],types.CREDENCIAMENTO.GET_CREDENCIAL);

            return response.data[0];

        }catch(error){
            dispatchresponseerror(dispatch,error);
        }
    }
}

export const pesquisa = (filtro = {}) => {
    
    return async dispatch => {

        dispatchpending(dispatch);

        try{
            const response = await axios.get('credenciais/credencial/pesquisa',
                {
                    headers:{
                        Accept: 'application/json',
                        Authorization: `Bearer ${getToken()}`
                    },
                    params:{
                        ...filtro
                    }
                }
            );
            
            dispatchresponse(dispatch,response.data[0]?response.data[0]:{},types.CREDENCIAMENTO.PESQUISA_CADASTRO);

            return response.data[0]?response.data[0]:{};

        }catch(error){
            dispatchresponseerror(dispatch,error);
        }
    }
}

export const pesquisaqtde = (filtro = {}) => {
    
    return async dispatch => {

        dispatchpending(dispatch);

        try{
            const response = await axios.get('credenciais/credencial/quantidades',
                {
                    headers:{
                        Accept: 'application/json',
                        Authorization: `Bearer ${getToken()}`
                    },
                    params:{
                        ...filtro
                    }
                }
            );
            
            dispatchresponse(dispatch,response.data?response.data:{},types.CREDENCIAMENTO.PESQUISA_QUANTIDADES);

            return response.data?response.data:{};

        }catch(error){
            dispatchresponseerror(dispatch,error);
        }
    }
}

export const notificaoconfirmacao = (dados = {}) => {
    
    return async dispatch => {

        dispatchpending(dispatch);

        try{
            const response = await axios.get('credenciais/notificacoes/confirmacao/credenciado',
                {
                    headers:{
                        Accept: 'application/json',
                        Authorization: `Bearer ${getToken()}`
                    },
                    params:{
                        ...dados
                    }
                }
            );

            dispatchresponse(dispatch,response.data?response.data:{},types.CREDENCIAMENTO.EMAIL_NOTI_CONFIRMACAO);
            return response.data?response.data:{};

        }catch(error){
            dispatchresponseerror(dispatch,error);
        }
    }
}

export const credencialPdf = (dados = {}) => {
    
    return async dispatch => {

        dispatchpending(dispatch);

        try{
            const response = await axios.post('helpers/credenciais/impressao',
                {
                    ...dados
                },
                {
                    headers:{
                        Accept: 'application/json',
                        Authorization: `Bearer ${getToken()}`                        
                    },
                    responseType: 'blob'
                }
            );
            
            dispatchresponse(dispatch,response.data?response.data:{},types.CREDENCIAMENTO.IMPRESSAOPDF);
            return response.data?response.data:{};

        }catch(error){
            dispatchresponseerror(dispatch,error);
        }
    }
}

export const credencialTodosPedidosPdfLink = (dados = {}) => {
    
    return async dispatch => {

        dispatchpending(dispatch);

        try{
            const response = await axios.get('credenciais/credencial/link/impressao',
                {
                    headers:{
                        Accept: 'application/json',
                        Authorization: `Bearer ${getToken()}`
                    },
                    params:{
                        ...dados
                    }
                }
            );
            
            dispatchresponse(dispatch,response.data?response.data:{},types.CREDENCIAMENTO.IMPRESSAOPDFTODOSPEDIDOS);
            return response.data?response.data:{};

        }catch(error){
            dispatchresponseerror(dispatch,error);
        }
    }
}

export const credencialTodosPedidosPdfBlob = (dados = {}) => {
    
    return async dispatch => {

        dispatchpending(dispatch);

        try{
            const response = await axios.get('credenciais/credencial/link/impressao',
                {
                    headers:{
                        Accept: 'application/json',
                        Authorization: `Bearer ${getToken()}`
                    },
                    responseType: 'blob',
                    params:{
                        ...dados
                    }
                }
            );
            
            dispatchresponse(dispatch,response.data?response.data:{},types.CREDENCIAMENTO.IMPRESSAOPDFTODOSPEDIDOS);
            return response.data?response.data:{};

        }catch(error){
            dispatchresponseerror(dispatch,error);
        }
    }
}

export const pesquisaformatoacesso = (filtro = {}) => {
    
    return async dispatch => {

        dispatchpending(dispatch);

        try{
            const response = await axios.get('credenciais/credencial/pesquisa/formatoacesso',
                {
                    headers:{
                        Accept: 'application/json',
                        Authorization: `Bearer ${getToken()}`
                    },
                    params:{
                        ...filtro
                    }
                }
            );
            
            dispatchresponse(dispatch,response.data,types.CREDENCIAMENTO.PESQUISA_CADASTRO_TODOS);

            return response.data;

        }catch(error){
            dispatchresponseerror(dispatch,error);
        }
    }
}

export const pesquisacompedido = (filtro = {}) => {
    
    return async dispatch => {

        dispatchpending(dispatch);

        try{
            const response = await axios.get('credenciais/credencial/pedido/pesquisa',
                {
                    headers:{
                        Accept: 'application/json',
                        Authorization: `Bearer ${getToken()}`
                    },
                    params:{
                        ...filtro
                    }
                }
            );
            
            dispatchresponse(dispatch,response.data,types.CREDENCIAMENTO.PESQUISA_CADASTRO_COM_PEDIDO);

            return response.data;

        }catch(error){
            dispatchresponseerror(dispatch,error);
        }
    }
}
